import axios from "axios";
import * as Constants from "../constant";
export const deleteAssets = async (UserId, assetId) => {
	try {
		const response = await axios.delete(
			`${Constants?.LOCAL_URL}/asset/${assetId}/${UserId}`
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
